"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeAllStandardCost = computeAllStandardCost;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const big_js_1 = __importDefault(require("big.js"));
function computeAllStandardCost(lines) {
    const totalLinePrice = lines.reduce((totalPrice, line) => {
        return totalPrice.plus(line.linePrice);
    }, (0, big_js_1.default)(0));
    return lines.reduce((bestPrice, line) => {
        if (!isStandardFeesSchedule(line.selectedLogisticOffer.feesSchedule))
            return bestPrice;
        if (bestPrice < (0, big_js_1.default)(line.selectedLogisticOffer.feesSchedule.standardRule.value).toNumber())
            return bestPrice;
        return line.selectedLogisticOffer.feesSchedule.standardRule.unit === module_logistic_interfaces_1.RuleUnit.Percent
            ? calculatePercentCost(line.selectedLogisticOffer.feesSchedule, totalLinePrice.toString())
            : calculateEuroCost(line.selectedLogisticOffer.feesSchedule);
    }, Infinity);
}
const isStandardFeesSchedule = (feesSchedule) => (feesSchedule === null || feesSchedule === void 0 ? void 0 : feesSchedule.type) === module_logistic_interfaces_1.FeesScheduleType.Standard && !!(feesSchedule === null || feesSchedule === void 0 ? void 0 : feesSchedule.standardRule);
function calculateEuroCost(feesSchedule) {
    var _a;
    return (0, big_js_1.default)((_a = feesSchedule === null || feesSchedule === void 0 ? void 0 : feesSchedule.standardRule) === null || _a === void 0 ? void 0 : _a.value).toNumber();
}
function calculatePercentCost(feesSchedule, totalLinePrice) {
    return (0, big_js_1.default)(totalLinePrice).mul(feesSchedule.standardRule.value).div(100).toNumber();
}
